import React from 'react';
import { Link } from "react-router-dom";
import LeftRight from "../../components/ui/LeftRight";
import sliderImage from '../../assets/images/services/pages/customize-software/cover.avif';
import { points, softwareServices } from "../../constants/services/customSoftware";
import verifySvg from "../../assets/images/verify.png";
import SlideUp from "../../components/ui/SlideUp";
import Expertise from "../../components/sections/Expertise";
import TechStack from "../../components/sections/TechStack";
import Contact from "../../components/sections/Contact";
import { useTranslation } from "react-i18next";
import settings from "../../constants/settings";
import { phoneIcon } from "../../constants/svgIcons";
import { customSoftwareMeta } from "../../constants/meta";
import Meta from "../../components/common/Helmet";

const CustomizedSoftware = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Meta
        title={customSoftwareMeta.title}
        description={customSoftwareMeta.description}
        canonical={customSoftwareMeta.canonical}
        keywords={customSoftwareMeta.keywords}
        ogTitle={customSoftwareMeta.title}
        ogDescription={customSoftwareMeta.description}
      />
      <div className="md:w-theme-container w-mobile-container mx-auto mt-12">
        <h2 className={`text-center md:w-[40%] mx-auto text-xl xl:text-xl md:text-2xl theme-font-bold uppercase mb-14`}>
          <span className="text-theme-color theme-font-bold">
            {t('customizedDevelopmentPage.sectionTitle')}
          </span> {t('customizedDevelopmentPage.sectionSubtitle')}
        </h2>
        <LeftRight
          isLeft={true}
          textWidthClass={'md:w-1/2'}
          textPosition={'justify-center'}
          descriptionPosition={'text-center'}
          sectionClass={'pb-0'}
          descriptionList={[
            t('customizedDevelopmentPage.introDescription')
          ]}
          icon={false}
          image={sliderImage}
        />
        <p className={`md:text-xl text-gray-700 leading-relaxed`}>
          {t('customizedDevelopmentPage.detailedDescription')}
        </p>
      </div>

      <div className="add-square-bg">
        <div className="md:w-theme-container w-mobile-container mx-auto py-24">
          <h2 className={`text-left text-3xl md:text-4xl  mb-14`}>
            {t('customizedDevelopmentPage.servicesTitle')}
          </h2>
          <p className={`md:text-xl text-gray-700 leading-relaxed`}>
            {t('customizedDevelopmentPage.servicesDescription')}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-14 mb-20">
            {/* Left Section */}
            <div className="flex-1 space-y-10">
              {softwareServices.map((service, index) => (
                <SlideUp key={index}>
                  <div className="flex items-start gap-4">
                    <div className={`p-5 ${service.bgColor} rounded-xl`}>
                      {service.svgIcon}
                    </div>
                    <div>
                      <h3 className="text-xl theme-font-bold">{t(`customizedDevelopmentPage.softwareServices.${service.translationKeys.title}`)}</h3>
                      <p className="text-gray-600">
                        {t(`customizedDevelopmentPage.softwareServices.${service.translationKeys.description}`)}
                      </p>
                      <Link
                        className="text-blue-600 text-sm hover:underline"
                        to={settings.domain + service.routePath}
                      >
                        See More
                      </Link>
                    </div>
                  </div>
                </SlideUp>
              ))}
            </div>

            {/* Right Section - Image */}
            <div className="flex-1">
              <SlideUp>
                <div className="w-full mx-auto">
                  <img
                    src={require('../../assets/images/services/pages/customize-software/cs-services.avif')}
                    alt="Team Planning"
                    className="cursor-pointer rounded-2xl shadow-lg w-full object-cover transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-2xl hover:brightness-105"
                  />
                </div>
              </SlideUp>
            </div>
          </div>

          <SlideUp>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:mt-32">
              <div className="w-full rounded-3xl overflow-hidden">
                <img
                  src={require('../../assets/images/services/pages/customize-software/coding-vector.avif')}
                  alt="Professionals working on laptops"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="space-y-6 flex flex-col justify-center items-start">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
                  {t('customizedDevelopmentPage.highlightLocation')}{' '}
                  <span className="text-theme-color">
                    {t('customizedDevelopmentPage.highlightService')}
                  </span>{' '}
                  {t('customizedDevelopmentPage.highlightCompanyType')}
                </h2>
                <p className="text-gray-700 text-base md:text-lg">
                  {t('customizedDevelopmentPage.highlightDescription')}
                </p>
                <div className="space-y-4">
                  {points.map((point, index) => (
                    <SlideUp key={index}>
                      <li className="flex items-start gap-3 text-gray-800">
                        <img
                          src={verifySvg}
                          alt="icon"
                          className="w-[25px] h-[25px]"
                        />
                        <span>{t(`customizedDevelopmentPage.${point}`)}</span>
                      </li>
                    </SlideUp>
                  ))}
                </div>
                <div>
                  <a
                    href={`tel:+971 4 2829 613`}
                    className="w-[130px] py-3 text-base mt-8 h-10 rounded-full bg-theme-color text-white text-center flex items-center justify-center gap-x-1"
                  >
                    {phoneIcon('#ffffff')} {t('common.callNow')}
                  </a>
                </div>
              </div>
            </div>
          </SlideUp>
        </div>
      </div>

      <div>
        <SlideUp>
          <Expertise />
        </SlideUp>
        <TechStack />
        <Contact />
      </div>
    </div>
  );
};

export default CustomizedSoftware;
